import { render, staticRenderFns } from "./CocListItem.vue?vue&type=template&id=478ed3fb&scoped=true"
import script from "./CocListItem.vue?vue&type=script&lang=js"
export * from "./CocListItem.vue?vue&type=script&lang=js"
import style0 from "./CocListItem.vue?vue&type=style&index=0&id=478ed3fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478ed3fb",
  null
  
)

export default component.exports